import { useQuery } from "@tanstack/react-query";
import { ToastService } from "@shared/lib/services";

import { useEffect } from "react";
import { AuthService } from "../services/Auth.service";
import {
  IBriefCampaignInfluencerSearchRequestV2,
  IGetPayoutsRequest,
} from "@shared/lib/types/briefCampains";

export function useGetBeUser(isEnabled: boolean = true) {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["be-user"],
    queryFn: () => AuthService.getBeUser(),
    enabled: isEnabled,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    beUser: data?.data,
    isLoading,
    isError,
    refetch,
  };
}
